module.exports = __webpack_public_path__ + "img/step2-img.bceada91.png";